// removed by extract-text-webpack-plugin
module.exports = {"headerRow":"_1HW14qWeBIbFAlf-KCCVUO","headerTitle":"XTQD8uYAbr0GJoK4mAXxA","title":"_10TOZkl0CgoOloKBN3Rapi","formLabel":"_3VgUst5eciKid-uE2M2Tqr","gender":"_3kjaHUOPNq2l2XhwFAHoZ6","formRadio":"_2IK_g4U_RIx16YPnyMvw9k","formRadioFirst":"_16SG423EULxAP9hLfddmx_","formFieldText":"TWGOamzsfgTp_daAGvIwD","saveButton":"_1XW7sLyzhiFDZ4xlC7rW4Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientMode/Welcome.css
// module id = 381
// module chunks = 0